import useOrderDocumentForm from 'tennders-documents/hooks/useOrderDocumentForm'
import OrderDocumentForm from 'tennders-documents/views/OrderDocumentForm'
import GModal from 'tennders-market/common/components/element/GModal'

function OrderDocumentModal({ ...rest }) {
  const {
    generateDoc,
    close
  } = useOrderDocumentForm()

  return (
    <GModal
      isOpen={generateDoc}
      size="90%"
      close={close}
      extraStyle={{ maxHeight: '90%', overflow: 'auto' }}
      {...rest}
    >
      <div className="tennders-modal-body w-100 p-32">
        <OrderDocumentForm />
      </div>
    </GModal>
  )
}

export default OrderDocumentModal
